<button type="button"
        class="link"
        aria-label="Go Back"
        (click)="goBackClicked()">
  <i class="fal fa-arrow-left"></i>
  <span class="ml-0025">Go Back</span>
</button>
